import { render, staticRenderFns } from "./channelBox.vue?vue&type=template&id=0bc359c9&scoped=true"
import script from "./channelBox.vue?vue&type=script&lang=js"
export * from "./channelBox.vue?vue&type=script&lang=js"
import style0 from "./channelBox.vue?vue&type=style&index=0&id=0bc359c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc359c9",
  null
  
)

export default component.exports